import { render, staticRenderFns } from "./materias.vue?vue&type=template&id=3b0bf906&"
import script from "./materias.vue?vue&type=script&lang=js&"
export * from "./materias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports